import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { bureauPlatformApi } from '@/utils/api';

import { WorkflowNode } from '../types';

const useCapabilityDeletion = (
  options?: UseMutationOptions<WorkflowNode, AxiosError, { id: string }>,
): UseMutationResult<WorkflowNode, AxiosError, { id: string }> => {
  return useMutation(deleteCapability, options);
};

const deleteCapability = async (data: { id: string }): Promise<WorkflowNode> => {
  // const url = `${process.env.REACT_APP_BASE_URL}/capabilities/${data?.id}`;
  const url = `/capabilities/${data?.id}`;

  const { data: response } = await bureauPlatformApi.delete<WorkflowNode>(url);
  return response;
};

export default useCapabilityDeletion;
